(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams','$scope','$uibModalInstance','entity','User','JhiLanguageService','Authority','CompanyCustomService','ToastrService'];

    function UserManagementDialogController ($stateParams, $scope, $uibModalInstance, entity, User, JhiLanguageService, Authority, CompanyCustomService, ToastrService) {
        var vm = this;

        //vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_TUI', 'ROLE_JPN', 'ROLE_LOTS'];
        vm.authorities = Authority.query();
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        vm.agents = [];

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        $scope.$watch('vm.user.authorities', function() {
           if(vm.user.authorities.includes('ROLE_AGENT')) {
               vm.showAgents = true;
               fetchAgents();
           }
        });

        function fetchAgents() {
            vm.agents = [];
            CompanyCustomService.returnCompaniesByType("AGENT").then(function(data) {
                vm.agents = data.data;
                if(vm.agents.length === 0) {
                    ToastrService.info("No Agents fetched", "Info");
                }
            }, function(error) {
                if(error.status !== "404") {
                    ToastrService.error("Cannot fetch Agents", "Error");
                }
            });
        }
    }
})();
